<div class="titled-input-wrapper {{ type }}"
  [ngClass]="{ 'disabled': isDisabled, 'invalid':isInvalid}">
  <ng-container *ngIf="title">
    <div class="title-container">
      <label class="titled-input-label">{{ title }}</label>
      <div class="tooltip-icon-container">
        <ng-content select="app-tooltip-icon"></ng-content>
      </div>
    </div>
  </ng-container>
  <ng-content></ng-content>
  <div class="error" *ngIf="isInvalid"> {{ errorMessage }}</div>
</div>
